import { Grid } from "@mui/material";
import MxIcons from "@rf-l1/MxIcons";
import MxTypography from "@rf-l1/MxTypography";
import { IconInfoCircle } from "@tabler/icons-react";
import MxTooltipBasic from "@rf-l1/tooltip/MxTooltipBasic";

interface SeoTitleField {
  label: string;
  infoIconMsg: string;
  infoButtonMsg: string;
  keySignal: string;
  onClick: () => void;
  loading?: boolean;
}
const SeoTitleField = (props: SeoTitleField) => {
  return (
    <Grid container>
      <Grid item>
        <Grid container alignItems="center" item xs={12} gap={1}>
          <Grid item xs="auto">
            <Title label={props.label} />
          </Grid>
          <Grid item xs="auto">
            <MxTooltipBasic sx={{ width: 250 }} msg={props.infoIconMsg}>
              <MxIcons size={14} color="primary.main">
                <IconInfoCircle />
              </MxIcons>
            </MxTooltipBasic>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SeoTitleField;

const Title = ({ label }: { label: string }) => {
  return (
    <MxTypography variant="subtitle2" color="primary.main">
      {label}
    </MxTypography>
  );
};
